import { render, staticRenderFns } from "./TournamentSchedule.vue?vue&type=template&id=9e5fe118&scoped=true"
import script from "./TournamentSchedule.vue?vue&type=script&lang=js"
export * from "./TournamentSchedule.vue?vue&type=script&lang=js"
import style0 from "./TournamentSchedule.vue?vue&type=style&index=0&id=9e5fe118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5fe118",
  null
  
)

export default component.exports